import { TileLayer } from "leaflet";

export const arcGisElevation = (attribution?: boolean) => new TileLayer(
  'https://services.arcgisonline.com/arcgis/rest/services/Elevation/World_Hillshade/MapServer/tile/{z}/{y}/{x}',
  (attribution || attribution === undefined) ? { attribution: '&copy; <a href="https://server.arcgisonline.com">ArcGis</a> contributors' } : undefined,
);

export const arcGisOceanos = (attribution?: boolean) => new TileLayer(
  'https://services.arcgisonline.com/arcgis/rest/services/Ocean/World_Ocean_Base/MapServer/tile/{z}/{y}/{x}',
  (attribution || attribution === undefined) ? { attribution: '&copy; <a href="https://server.arcgisonline.com">ArcGis</a> contributors' } : undefined,
);

export const arcGisTerritorio = (attribution?: boolean) => new TileLayer(
  'https://services.arcgisonline.com/arcgis/rest/services/Elevation/World_Hillshade/MapServer/tile/{z}/{y}/{x}',
  (attribution || attribution === undefined) ? { attribution: '&copy; <a href="https://server.arcgisonline.com">ArcGis</a> contributors' } : undefined,
);

export const arcGisGeografiaNacional = (attribution?: boolean) => new TileLayer(
  'https://services.arcgisonline.com/arcgis/rest/services/Elevation/World_Hillshade/MapServer/tile/{z}/{y}/{x}',
  (attribution || attribution === undefined) ? { attribution: '&copy; <a href="https://server.arcgisonline.com">ArcGis</a> contributors' } : undefined,
);

export const arcGisAntigo = (attribution?: boolean) => new TileLayer(
  'https://server.arcgisonline.com/arcgis/rest/services/Elevation/World_Hillshade/MapServer/tile/{z}/{y}/{x}',
  (attribution || attribution === undefined) ? { attribution: '&copy; <a href="https://server.arcgisonline.com">ArcGis</a> contributors' } : undefined,
);

export const arcGisVagalume = (attribution?: boolean) => new TileLayer(
  'https://fly.maptiles.arcgis.com/arcgis/rest/services/World_Imagery_Firefly/MapServer/tile/{z}/{y}/{x}',
  (attribution || attribution === undefined) ? { attribution: '&copy; <a href="https://server.arcgisonline.com">ArcGis</a> contributors' } : undefined,
);

export const arcGisHibrid = (attribution?: boolean) => new TileLayer(
  'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
  (attribution || attribution === undefined) ? { attribution: '&copy; <a href="https://server.arcgisonline.com">ArcGis</a> contributors' } : undefined,
);

export const openStreet = (attribution?: boolean) => new TileLayer(
  'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
  (attribution || attribution === undefined) ? { attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' } : undefined,
);

export const googleRoads = (attribution?: boolean) => new TileLayer(
  "https://mt.google.com/vt/lyrs=m&x={x}&y={y}&z={z}",
  (attribution || attribution === undefined) ? { attribution: '&copy; <a href="https://www.google.com/intl/pt-BR_BR/help/terms_maps/">Google</a>' } : undefined,
);

export const googleSatelite = (attribution?: boolean) => new TileLayer(
  "https://mt.google.com/vt/lyrs=s&x={x}&y={y}&z={z}",
  (attribution || attribution === undefined) ? { attribution: '&copy; <a href="https://www.google.com/intl/pt-BR_BR/help/terms_maps/">Google</a>' } : undefined,
);

export const googleHibrido = (attribution?: boolean) => new TileLayer(
  "https://mt.google.com/vt/lyrs=y&x={x}&y={y}&z={z}",
  (attribution || attribution === undefined) ? { attribution: '&copy; <a href="https://www.google.com/intl/pt-BR_BR/help/terms_maps/">Google</a>' } : undefined,
);

export const googleTerrain = (attribution?: boolean) => new TileLayer(
  "https://mt.google.com/vt/lyrs=t&x={x}&y={y}&z={z}",
  (attribution || attribution === undefined) ? { attribution: '&copy; <a href="https://www.google.com/intl/pt-BR_BR/help/terms_maps/">Google</a>' } : undefined,
);

export const googleStreet = (attribution?: boolean) => new TileLayer(
  "https://mt.google.com/vt/lyrs=p&x={x}&y={y}&z={z}",
  (attribution || attribution === undefined) ? { attribution: '&copy; <a href="https://www.google.com/intl/pt-BR_BR/help/terms_maps/">Google</a>' } : undefined,
);

export const googleAltered = (attribution?: boolean) => new TileLayer(
  "https://mt.google.com/vt/lyrs=h&x={x}&y={y}&z={z}",
  (attribution || attribution === undefined) ? { attribution: '&copy; <a href="https://www.google.com/intl/pt-BR_BR/help/terms_maps/">Google</a>' } : undefined,
);

export const googleStreetSimple = (attribution?: boolean) => new TileLayer(
  "https://mt.google.com/vt/lyrs=r&x={x}&y={y}&z={z}",
  (attribution || attribution === undefined) ? { attribution: '&copy; <a href="https://www.google.com/intl/pt-BR_BR/help/terms_maps/">Google</a>' } : undefined,
);

export const googleSateliteHybrid = (attribution?: boolean) => new TileLayer(
  "https://mt.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}",
  (attribution || attribution === undefined) ? { attribution: '&copy; <a href="https://www.google.com/intl/pt-BR_BR/help/terms_maps/">Google</a>' } : undefined,
);

export const googleSateliteRoad = (attribution?: boolean) => new TileLayer(
  "https://mt.google.com/vt/lyrs=s,m&x={x}&y={y}&z={z}",
  (attribution || attribution === undefined) ? { attribution: '&copy; <a href="https://www.google.com/intl/pt-BR_BR/help/terms_maps/">Google</a>' } : undefined,
);

export const googleSateliteTerrain = (attribution?: boolean) => new TileLayer(
  "https://mt.google.com/vt/lyrs=s,t&x={x}&y={y}&z={z}",
  (attribution || attribution === undefined) ? { attribution: '&copy; <a href="https://www.google.com/intl/pt-BR_BR/help/terms_maps/">Google</a>' } : undefined,
);


export const tilesNames = {
  "ArcGIS Elevation": arcGisElevation,
  "ArqGIS Oceanos": arcGisOceanos,
  "ArqGIS Território": arcGisTerritorio,
  "ArqGIS Geografia": arcGisGeografiaNacional,
  "ArqGIS Antigo": arcGisAntigo,
  "ArqGIS Vagalume": arcGisVagalume,
  "ArqGIS Hibrid": arcGisHibrid,
  "Open Street Maps": openStreet,
  "Google Roads": googleRoads,
  "Google Satelite": googleSatelite,
  "Google Hibrido": googleHibrido,
  "Google Terrain": googleTerrain,
  "Google Street": googleStreet,
  "Google Altered": googleAltered,
  "Google Street Simples": googleStreetSimple,
  "Google Satelite & Hibrido": googleSateliteHybrid,
  "Google Satelite & Roads": googleSateliteRoad,
  "Google Satelite & Terrain": googleSateliteTerrain,
};